<template lang="pug">
.columns.mt-2.pt-2
  .column.col-12.bg-gray.p-1 Sobre o cadastro
  .columns.column.col-12.mt-1
    .column.col-3.col-sm-12.mt-1
      div
        .text-small {{ 'cadastro.situacao' | tModel }}
        .text-bold {{ current.situacao.descricao }}
    .column.col-3.col-sm-12.mt-1
      div
        .text-small {{ 'cadastro.zona' | tModel }}
        .text-bold {{ current.zona || '-' }}
    .column.col-3.col-sm-12.mt-1
      div
        .text-small {{ 'cadastro.quadra' | tModel }}
        .text-bold {{ current.quadra || '-' }}
    .column.col-3.col-sm-12.mt-1
      div
        .text-small {{ 'cadastro.lote' | tModel }}
        .text-bold {{ current.lote || '-' }}

  .column.col-12.bg-gray.p-1.mt-2 {{ 'cadastro.endereco' | tModel }}
  .columns.column.col-12.mt-1
    .column.col-12 {{ current.endereco_formatado }}

  .columns.column.col-12(v-if="current.cadastro_imobiliario && current.cadastro_imobiliario.latitude && current.cadastro_imobiliario.longitude")
    .column.col-12.bg-gray.p-1.mt-2 Mapa
    .columns.column.col-12.mt-1
      .column.col-12
        v-map.map(:center="location" :zoom="14")
          v-marker(:position="location")

</template>

<script>
import { vuexDefaultMapping } from '@/mixins/show'

export default {
  computed: {
    location() {
      if (
        this.current &&
        this.current.cadastro_imobiliario &&
        this.current.cadastro_imobiliario.latitude &&
        this.current.cadastro_imobiliario.longitude
      ) {
        const { latitude, longitude } = this.current.cadastro_imobiliario
        return { lat: latitude, lng: longitude }
      }

      return null
    },
  },
  vuex: { cadastros: vuexDefaultMapping },
}
</script>

<style lang="stylus" scoped>
.map
  height 350px
</style>
